


































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import { formatCurrency } from "@/shared/currency";
import moment from "moment";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { usePersonalContributionSchedulesStore } from "@/shared/store/personalContributionSchedules";

interface ContributionRow {
  date: string;
  amount: string;
  bankAccountName: string;
  status: string;
}

@Component ({
  components: {
    GenericLoadingSpinner,
    Pagination
  }
})
export default class FutureContributions extends Vue {

  bankAccountStore = useBankAccountStore();
  contributionSchedulesStore = usePersonalContributionSchedulesStore();

  formatCurrency = formatCurrency;
  tableRows: ContributionRow[] = [];

  tableFields = [
    {
      key: "date",
      label: "Date",
    },
    {
      key: "amount",
      label: "Amount",
    },
    {
      key: "bankAccountName",
      label: "Bank Account"
    },
    {
      key: "status",
      label: "Status",
      thClass: "d-none d-md-table-cell",
      tdClass: "d-none d-md-table-cell"
    }
  ];

  @Prop({required: true})
  page: number;

  @Prop({required: false})
  username: string;

  @Prop({required: false})
  partnerId: number;

  mounted (): void {
    this.bankAccountStore.loadLinkedBankAccounts();

    const args = { username: this.username, partnerId: this.partnerId };
    this.contributionSchedulesStore.getFutureContributions(args);

    if (this.contributionSchedulesStore.isFutureContributionsLoaded) {
      this.loadPage();
    }
  }

  get isLoaded (): boolean {
    return this.bankAccountStore.linkedAccountsLoaded && this.contributionSchedulesStore.isFutureContributionsLoaded;
  }

  @Watch("contributionSchedulesStore.isFutureContributionsLoaded")
  loadedUpdated (value) {
    if (!value && !this.contributionSchedulesStore.futureContributionsLoading) {
      const args = { username: this.username, partnerId: this.partnerId };
      this.contributionSchedulesStore.getFutureContributions(args);
    }

    this.tableRows = this.buildTableRows();
  }

  @Watch("page")
  loadPage () {
    this.tableRows = this.buildTableRows();
  }

  buildTableRows (): ContributionRow[] {
    if (!this.contributionSchedulesStore.isFutureContributionsLoaded) {
      return [];
    }

    return this.contributionSchedulesStore.futureContributionsPage(this.page).map(x => {
      return {
        date: this.getFormattedDate(x.calendarDate),
        amount: formatCurrency(x.amount),
        bankAccountName: this.getAccountName(x.linkedExternalBankAccountId),
        status: this.getFormattedStatus(x.status)
      };
    });
  }

  getFormattedDate (date?: string): string {
    return date && moment(date).format("MMM D, YYYY") || "None";
  }

  getAccountName (accountId: number | string): string {
    const index = this.bankAccountStore.verifiedLinkedAccounts.findIndex(x => x.linkedBankAccountId === accountId);
    if (index < 0) {
      return accountId.toString();
    }

    return this.bankAccountStore.verifiedLinkedAccounts[index].bankAccountName;
  }

  getFormattedStatus (status: string): string {
    return status === "active" ? "Active" : "";
  }

  switchPage (newPage) {
    this.$router.push({query: {...this.$route.query, futureContributionsPage: newPage}});
  }
}
